/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useState, useEffect, useCallback} from 'react'
import {DebounceInput} from 'react-debounce-input';
import AddressHover from '../AddressChangeModal/AddressHover';
import ItemPriceTooltip from '../ItemPriceTooltip';
import debounce from 'lodash.debounce';

function ProposedComponent({selectedAddressObj,handleConfirm,orderFlow,
    setselectedAddressObj,prod,proposedCount,setaddresChangeModal,
    setproposedCount}) {
    const [TypeToggle, setTypeToggle] = useState('₹');
    const [addressSemiModal, setaddressSemiModal] = useState('');
    const [viewAddress, setviewAddress] = useState('')
    const [currentValue, setCurrentValue] = useState(prod?.proposed_amount);
    const [value, setValue] = useState(prod?.proposed_amount);
    const [dbValue, saveToDb] = useState('');
    const [ItemPricehoverId, setitemPricehoverId] = useState('');
    const [subTotalhoverId, setSubTotalhoverId] = useState('');
    const [nexttoProposedDiscountItemPricehoverId, setnexttoProposedDiscountitemPricehoverId] = useState('');


    const paylod = (data,type)=>{
        return {
            total_price:handlePrice(data),
            user_input:data[prod.item_id],
            count:proposedCount[prod.item_id],

            type:type?type:TypeToggle==='₹'?'₹':'%'

        }
    }
    useEffect(() => {
        setTypeToggle(prod?.proposed_type==='₹'?'₹':'%')
    }, [])
    
    const setProposedPrice = (val, value) => {
        let amount = ''
        let data = {...proposedCount}
        if(val !==''){
            if(Number(val) < Number(prod?.sub_total-prod?.discount_applied))
                data[prod.item_id] = Number(val)
        }
        else{
            data[prod.item_id] = 0
        }
        const propose=paylod(data)
        debouncedSave(prod.quantity,prod,propose)
        setproposedCount(data)
    }

    const debouncedSave = useCallback(
        debounce((quantity,prod,propose) => {
            handleConfirm(quantity,prod,propose)
        }, 1000),
        [], // will be created only once initially
    );
    // highlight-ends

    const handlePrice=(item)=>{
        const amnt=TypeToggle == "₹" ? Number(item[prod.item_id]):
            Number(prod.total_price) - ((item[prod.item_id] / 100) * Number(prod.total_price))
        return amnt
    }
    const handleTypeToggle=(type)=>{
        setTypeToggle(type);
        const obj={...proposedCount}
        if(type ==='%' && Number(obj[prod.item_id]) > 99.99){
            obj[prod.item_id]=0;
            setCurrentValue(0)
        }
        setproposedCount(obj)
        const payload =paylod(obj,type);
        if(proposedCount[prod.item_id] !==''){
            handleConfirm(prod.quantity,prod,payload)
        }
    }
    const AddressDropNew=({keyVal,header,selectedAddressObj,prod,setaddresChangeModal})=>(
        <>
            <div className="flex items-center justify-between">
                <p className="sm:text-xs6 text-sm font-semibold text-[#808285]">{header} address</p>
                <button type="button" className="sm:text-xs6 text-sm font-semibold text-[#808285] change" data-bs-toggle="modal" data-bs-target="#changeaddressModal" onClick={()=>{
                    setaddressSemiModal('');
                    setaddresChangeModal(keyVal)
                }}>View </button>
            </div>
            {/* <p className="sm:pr-14 pr-9 sm:pt-2 pt-1.5 sm:text-base text-sm font-normal text-[#15090E]">
                {selectedAddressObj[prod.item_id][key]?.ADDRESS1}
            </p> */}
            <p>{selectedAddressObj[prod.item_id][keyVal]?.ADDRESS1},</p>
            <p>{selectedAddressObj[prod.item_id][keyVal]?.ADDRESS2},</p>
            <p>{selectedAddressObj[prod.item_id][keyVal]?.ADDRESS3},{selectedAddressObj[prod.item_id][keyVal]?.ADDRESS4}</p>
            <p>Pincode-{`${selectedAddressObj[prod.item_id][keyVal]?.POSTAL_CODE}`},{`GSTIN-${selectedAddressObj[prod.item_id][keyVal]?.SITE_GSTIN || '-'}`}</p>         
        </>
    )
       
    
    return (
        <>
            <div className="w-full lg:px-2 mt-2.5 mb-3.5">
                <div className="flex items-center xl:flex-row flex-col">
                    <div className="xl:w-[70%] w-full pl-4 pr-2 pb-2 pt-2.5 bg-[#F5F5FA] rounded-lg flex justify-around">
                        <div className="pr-2">
                            <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.PACKING_SIZE||1} {prod?.PRIMARY_UOM_CODE}</p>
                        </div>
                        <div className="px-2">
                            <p className="text-xs font-semibold text-[#808285]">Size</p>
                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                <>
                                    <>{`${prod.DIAMETER!==null ?`${prod.DIAMETER}mm`:''}`}</>
                                    <>{`${prod.LENGTH!==null && prod.DIAMETER ? 'x':''}`}</>
                                    <>{`${prod.LENGTH!==null ?`${prod.LENGTH}mm`:''}`}</>
                                    <>{prod.LENGTH===null && prod.DIAMETER===null ? '-':''}</>
                                </>
                            </p>
                        </div>
                        <div className="px-2">
                            <p className="text-xs font-semibold text-[#808285]">Quantity</p>
                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.quantity} {prod?.PRIMARY_UOM_CODE}</p>
                        </div>
                        <div className="px-2">
                            <p className="text-xs font-semibold text-[#808285]">List Price</p>
                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Number(prod?.LIST_PRICE).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            })}</p>
                        </div>
                        <div className="m:px-2 pt-2 sm:pt-0 sm:border-r ">
                            <p className="text-xs font-semibold text-[#808285]">DAP</p>
                            <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Number(prod?.dap).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            })}</p>
                        </div>
                    </div>
                    <div className="xl:w-[38%] w-full flex sm:nowrap flex-wrap justify-start px-4 pt-2.5 pb-2 shadow-s9 rounded-lg xl:mt-0 mt-3 relative xl:h-[53px] h-auto">
                        <button type="button" className="pr-2 border-r border-[#CECECE] flex justify-between items-center xl:auto sm:w-1/2 w-full text-left showAddress-full2">
                            <div onClick={()=>{
                                if(viewAddress===''){
                                    setviewAddress('billing')
                                }else{
                                    setviewAddress('')
                                }
                            }}>
                                <p className="text-xs font-semibold text-[#808285]">Billing address</p>
                                <p className="text-xs6 font-semibold text-[#555259] more-lines">{selectedAddressObj[prod.item_id]?.billing_address?.ADDRESS1?.slice(20)}</p>
                            </div>
                            <p className="font-semibold text-xs12 text-[#808285] cursor-pointer" 
                                onClick={()=>{
                                    if(viewAddress===''){
                                        setviewAddress('billing')
                                    }else{
                                        setviewAddress('')
                                    }
                                }}>View
                            </p>
                        </button>
                        <div style={{zIndex: '10'}}  className={`absolute top-[50px] left-0 bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-[10] adderess-show2 ${addressSemiModal==='billing'?'show':'hidden'}`}>
                            {Object.keys(selectedAddressObj.billing_address).length > 0 &&<AddressDropNew 
                                keyVal='billing_address'
                                header='billing'
                                selectedAddressObj={selectedAddressObj}
                                prod={prod}
                                setaddresChangeModal={setaddresChangeModal}/>}
                        </div>
                        {viewAddress==='billing' && <AddressHover type="billing" address={selectedAddressObj[prod.item_id]?.billing_address}/>}

                        <div className="sm:px-2 px-0 xl:auto sm:w-1/2 w-full flex justify-between items-center sm:mt-0 mt-2 cursor-pointer">
                            <div onClick={()=>{
                                if(viewAddress===''){
                                    setviewAddress('shipping')
                                }else{
                                    setviewAddress('')
                                }
                            }}>
                                <p className="text-xs font-semibold text-[#808285]">Shipping address</p>
                                <p className="text-xs6 font-semibold text-[#555259] more-lines">{selectedAddressObj[prod.item_id]?.shipping_address?.ADDRESS1?.slice(20)}</p>
                            </div>
                            <p className="font-semibold text-xs12 text-[#808285] cursor-pointer" 
                                onClick={()=>{
                                    if(viewAddress===''){
                                        setviewAddress('shipping')
                                    }else{
                                        setviewAddress('')
                                    }
                                }}>View
                            </p>
                        </div>
                        {viewAddress==='shipping' && <AddressHover type="shipping" address={selectedAddressObj[prod.item_id]?.shipping_address}/>}

                        <div className={`absolute top-[50px] right-0 bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-[10] adderess-show2 ${addressSemiModal==='shipping'?'show':'hidden'}`}>
                            {Object.keys(selectedAddressObj.shipping_address).length > 0 &&<AddressDropNew 
                                keyVal='shipping_address'
                                header='shipping'
                                selectedAddressObj={selectedAddressObj}
                                prod={prod}
                                setaddresChangeModal={setaddresChangeModal}/>}
                        </div>
                    </div>
                </div>
            </div>
            <>
                {orderFlow.order_type==='Trade EUB Order'?
                    <div className="pt-3 border-t border-[#CBCBCB] w-full flex items-center xl:flex-row flex-col lg:px-2 px-0">
                        <div className="flex -mx-2 w-full sm:nowrap flex-wrap">
                            <div className="sm:w-1/3 w-1/2 px-2 mt-3">
                                <div className="bg-[#F5F5FA] rounded-lg text-center py-1.5">
                                    <p className="text-xs font-semibold text-[#808285]">Sub Total</p>
                                    <div className="flex justify-center items-center">
                                        <p className="text-base font-semibold text-[#15090E] mr-1">{Number(prod?.sub_total-prod?.discount_applied).toLocaleString('en-IN', {
                                            style: 'currency',
                                            currency: 'INR',
                                        })}</p>
                                        <span>
                                            <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                                setTimeout(() => {
                                                    setSubTotalhoverId(prod.INVENTORY_ITEM_ID)
                                                }, 100);
                                            }} onMouseLeave={()=>{
                                                setSubTotalhoverId('')
                                            }}>
                                                <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                            </button>
                                            <>
                                                {
                                                    subTotalhoverId=== prod.INVENTORY_ITEM_ID &&(
                                                        (() => {
                                                            const subTotal = Number(prod?.sub_total) || 0;
                                                            const discountApplied = Number(prod?.discount_applied) || 0;
                                                            const netAmount = subTotal - discountApplied;
                                                            // Calculate net discount: (sub_total - net_amount) / sub_total * 100
                                                            const netDiscount = subTotal > 0 ? ((subTotal - netAmount) / subTotal) * 100 : 0;
                                                            return (
                                                                <ItemPriceTooltip 
                                                                    hover={true} 
                                                                    prod={prod} 
                                                                    itemPriceValue={netAmount/prod?.quantity}
                                                                    netDiscount={isNaN(netDiscount) ? 0 : netDiscount}
                                                                    onMouseEnter={()=>{
                                                                        setSubTotalhoverId(prod.INVENTORY_ITEM_ID)
                                                                    }}
                                                                    onMouseLeave={()=>{
                                                                        setSubTotalhoverId('')
                                                                    }}
                                                                />
                                                            );
                                                        })()
                                                    )}
                                            </>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="sm:w-1/3 w-1/2 px-2">
                                <p className="text-xs2 font-semibold text-[#808285] bg-[#FFFFFF] py-1">Proposed Discount</p>
                                <div className="flex items-center w-full">
                                    <div className="border border-[#D8DDE3] rounded-lg h-[40px] relative p-1 mr-2 w-full">
                                        <div className="flex">
                                            <ul className="nav nav-pills flex border border-[#555259] rounded-[5px]" id="pills-tabVertical" role="tablist">
                                                <li  onClick={()=>handleTypeToggle('₹')} className="nav-item flex-grow  text-center ml-[-1px]" role="presentation">
                                                    <a href="javascript:void(0)" className={`nav-link block ${TypeToggle==='₹'?'active':''} offer-currency font-semibold text-[#555259] text-xs19 w-[30px]`} id="pill1" data-bs-toggle="pill" data-bs-target="#home1" role="tab" aria-controls="home1" aria-selected="true">
                                                        ₹
                                                    </a>
                                                </li>
                                                <li onClick={()=>handleTypeToggle('%')}className="nav-item flex-grow text-center mr-[-1px]" role="presentation">
                                                    <a href="javascript:void(0)" className={`nav-link block ${TypeToggle==='%'?'active':''} offer-currency font-semibold text-[#555259] text-xs19 w-[30px]`} id="pill2" data-bs-toggle="pill" data-bs-target="#home2" role="tab" aria-controls="home2" aria-selected="true">
                                                        %
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="pills-tabContentVertical">
                                                <div className="tab-pane fade show active" id="home1" role="tabpanel" aria-labelledby="pill1">
                                                    <input
                                                        minLength={1}
                                                        onWheel={(e) => e.target.blur()}
                                                        onKeyDown={ (event) => {
                                                            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') return event.preventDefault();
                                                            else return true;
                                                        }}
                                                        value={currentValue}
                                                        type="number"
                                                        className="w-full font-normal sm:text-lg text-base text-[#15090E] outline-0 text-right sm:py-0 py-1 appearance-none" 
                                                        onChange={(e)=>{
                                                            setCurrentValue(e.target.value)
                                                            if(Number(e.target.value) > -1 && (TypeToggle==='%' && e.target.value<100) || (TypeToggle==='₹' && e.target.value<Number(prod?.sub_total-prod?.discount_applied))){
                                                                setProposedPrice(e.target.value)
                                                                
                                                            }else{
                                                                setProposedPrice(0)
                                                                setCurrentValue(0)
                                                            }
                                                        }
                                                    
                                                        } />
                                                    {/* <input type="number" 
                                                onChange={(e)=>{
                                                    setProposedPrice(e.target.value)}}
                                                value={proposedCount[prod.item_id]}
                                                className="w-full font-normal sm:text-lg text-base text-[#15090E] outline-0 text-right sm:py-0 py-1" /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sm:w-1/3 w-full px-2 mt-3">
                                <div className="bg-[#F5F5FA] rounded-lg text-center py-1.5">
                                    <p className="text-xs font-semibold text-[#808285]">Proposed Total Price</p>
                                    <div className="flex justify-center items-center">
                                        <p className="text-base font-semibold text-[#15090E] mr-1">{Number(prod.proposed_total_price).toLocaleString('en-IN', {
                                            style: 'currency',
                                            currency: 'INR',
                                        })}</p>
                                        <span>
                                            <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                                setTimeout(() => {
                                                    setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                                }, 100);
                                            }} onMouseLeave={()=>{
                                                setitemPricehoverId('')
                                            }}>
                                                <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                            </button>
                                            <>
                                                {
                                                    ItemPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                                        (() => {
                                                            const subTotal = Number(prod?.sub_total) || 0;
                                                            const proposedTotalPrice = Number(prod.proposed_total_price) || 0;
                                                            const dap = Number(prod?.dap) || 0;
                                                            // Calculate net discount from original sub_total to proposed_total_price (excluding DAP)
                                                            // Formula: (sub_total - (proposed_total_price - dap)) / sub_total * 100
                                                            const netDiscount = subTotal > 0 ? ((subTotal - (proposedTotalPrice - dap)) / subTotal) * 100 : 0;
                                                            return (
                                                                <ItemPriceTooltip 
                                                                    hover={true} 
                                                                    prod={prod} 
                                                                    itemPriceValue={proposedTotalPrice/prod?.quantity}
                                                                    netDiscount={isNaN(netDiscount) ? 0 : netDiscount}
                                                                    onMouseEnter={()=>{
                                                                        setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                                                    }}
                                                                    onMouseLeave={()=>{
                                                                        setitemPricehoverId('')
                                                                    }}
                                                                />
                                                            );
                                                        })()
                                                    )}
                                            </>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="pt-3 border-t border-[#CBCBCB] w-full flex items-center xl:flex-row flex-col lg:px-2 px-0">
                        <div className="w-full">
                            <div className="bg-[#F5F5FA] rounded-lg text-center py-1.5">
                                <p className="text-xs font-semibold text-[#808285]">Total Price</p>
                                <div className="flex items-center justify-center pt-0.5">
                                    <p className="text-base font-semibold text-[#15090E] mr-2">{Number(prod.total_price).toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })}
                                    </p>
                                    <span>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setitemPricehoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                        </button>
                                        <>
                                            {
                                                ItemPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    (() => {
                                                        const subTotal = Number(prod?.sub_total) || 0;
                                                        const totalPrice = Number(prod.total_price) || 0;
                                                        const dap = Number(prod?.dap) || 0;
                                                        // Subtract DAP from totalPrice for net discount calculation
                                                        const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                                        return (
                                                            <ItemPriceTooltip 
                                                                hover={ItemPricehoverId=== prod.INVENTORY_ITEM_ID} 
                                                                prod={prod} 
                                                                itemPriceValue={totalPrice/prod?.quantity}
                                                                netDiscount={netDiscount}
                                                                onMouseEnter={()=>{
                                                                    setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                                                }}
                                                                onMouseLeave={()=>{
                                                                    setitemPricehoverId('')
                                                                }}
                                                            />
                                                        );
                                                    })()
                                                )}
                                        </>
                                        {(() => {
                                            const subTotal = Number(prod?.sub_total) || 0;
                                            const totalPrice = Number(prod.total_price) || 0;
                                            const dap = Number(prod?.dap) || 0;
                                            // Subtract DAP from totalPrice for net discount calculation
                                            const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                            return (
                                                <ItemPriceTooltip 
                                                    prod={prod} 
                                                    itemPriceValue={totalPrice/prod?.quantity}
                                                    netDiscount={netDiscount}
                                                />
                                            );
                                        })()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        </>
    )
}

export default ProposedComponent